var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useAnalytics, } from '../analytics-provider/analytics-provider';
const AnalyticsTrigger = (props) => {
    const { push } = useAnalytics();
    function enhanceItem(child) {
        if (React.isValidElement(child)) {
            const triggers = Array.isArray(props.trigger) ? props.trigger : [props.trigger];
            const propsWithTriggers = triggers.reduce((prevProps, currentTrigger) => {
                const { id, callback, elementId, interactionType } = currentTrigger, rest = __rest(currentTrigger, ["id", "callback", "elementId", "interactionType"]);
                return Object.assign(Object.assign({}, prevProps), { [callback]: (...args) => {
                        push(typeof id === 'function' ? id(args) : id, typeof elementId === 'function' ? elementId(args) : elementId, typeof interactionType === 'function' ? interactionType(args) : interactionType, rest);
                        if (child.props[callback]) {
                            child.props[callback](...args);
                        }
                    } });
            }, {});
            return React.cloneElement(child, propsWithTriggers);
        }
    }
    return (React.createElement(React.Fragment, null, React.Children.map(props.children, enhanceItem)));
};
export default AnalyticsTrigger;
